import styled from 'styled-components'
import { checkBy } from 'UTILS/theme'

interface MediaProps {
  platform: 'pc' | 'mobile' | 'all' | 'none'
}

const Media = styled.div<MediaProps>`
  ${checkBy('platform', {
    pc: `
      @media screen and (max-width: 600px) {
        height: 0;
        width: 0;
        opacity: 0;
        overflow: hidden;
        user-select: none;
        pointer-events: none;
      }
    `,
    mobile: `
      height: 0;
      width: 0;
      opacity: 0;
      overflow: hidden;
      user-select: none;
      pointer-events: none;
      @media screen and (max-width: 600px) {
        height: unset;
        width: unset;
        opacity: unset;
        overflow: unset;
        user-select: unset;
        pointer-events: unset;
      }
    `,
    all: ``,
    none: `
      height: 0;
      width: 0;
      opacity: 0;
      overflow: hidden;
    `,
  })}
`

export default Media
